export const YTD = "YTD";

export const SEGMENTABLE_STATS = [
  "totalWeight",
  "totalDonations",
  "activeGardeners",
  "newGardeners",
  "chats"
];

export const buildYearOptions = (availableYears) =>
  [YTD, ...availableYears.map(String)];

export const getComparisonYear = (year) => {
  const currentYear = new Date().getFullYear();
  if (year === YTD || !year) return String(currentYear - 1);
  const y = parseInt(year, 10);
  return Number.isNaN(y) ? null : String(y - 1);
};

export const computeDelta = (current, comparison) => {
  if (current == null || comparison == null) return null;
  const diff = current - comparison;
  const direction = diff < 0 ? "down" : "up";
  const magnitude = Math.abs(diff);
  const text = diff < 0 ? String(magnitude) : `+${magnitude}`;
  return { direction, text, diff };
};

export function formatDecimal(v, decimals = 2) {
  if (v == null) return "-";
  const num = parseFloat(v);
  return num % 1 === 0 ? String(Math.round(num)) : num.toFixed(decimals);
}

export function formatWeight(w) {
  if (w == null) return "-";
  if (w >= 1_000_000_000) return `${(w / 1_000_000_000).toFixed(1)}B`;
  if (w >= 1_000_000) return `${(w / 1_000_000).toFixed(1)}M`;
  if (w >= 1_000) return `${(w / 1_000).toFixed(1)}k`;
  return Math.round(w).toLocaleString();
}

export function formatMonth(monthStr) {
  if (!monthStr) return "";
  const [year, month] = monthStr.split("-");
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${months[parseInt(month, 10) - 1]} ${year.slice(2)}`;
}
